import styled from 'styled-components';

export const Span = styled.span``;
export const Div = styled.div``;
